import { numericFormatter } from "react-number-format";
import { columns } from "../../../../dtos/columns";
import { RespuestaRegistrosEnviados } from "../models/respuestaRegistrosEnviadosDto";
import { Checkbox } from "@mui/material";

interface IProps {
  idsToDownload: number[];
  setIdsToDownload: React.Dispatch<React.SetStateAction<number[]>>;
}

interface IProps {
  controlTabla: any;
  idsToDownload: number[];
  setIdsToDownload: React.Dispatch<React.SetStateAction<number[]>>;
}

export function useColumnsResumenEnviados({ controlTabla, idsToDownload, setIdsToDownload }: IProps) {
  const COLUMNS: columns<RespuestaRegistrosEnviados>[] = [
    {
      name: (
        <Checkbox
          size="small"
          checked={
            controlTabla?.data?.length > 0 &&
            idsToDownload.length === controlTabla.data.length
          }
          indeterminate={
            idsToDownload.length > 0 &&
            idsToDownload.length < (controlTabla?.data?.length ?? 0)
          }
          onChange={e => {
            if (e.target.checked && controlTabla?.data) {
              setIdsToDownload(controlTabla.data.map((item: RespuestaRegistrosEnviados) => item.id));
            } else {
              setIdsToDownload([]);
            }
          }}
        />
      ),
      selector: (row: RespuestaRegistrosEnviados) => row.id,
      cell: (row: RespuestaRegistrosEnviados) => (
        <Checkbox
          size="small"
          checked={idsToDownload.includes(row.id)}
          onChange={e => {
            setIdsToDownload(prev =>
              e.target.checked
                ? [...prev, row.id]
                : prev.filter(id => id !== row.id)
            );
          }}
        />
      ),
      allowOverflow: true,
      button: true,
      export: false,
      width: '60px',
    },
    {
      name: "Id",
      selector: (row: RespuestaRegistrosEnviados) => row.id ,
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Fecha envio",
      selector: (row: RespuestaRegistrosEnviados) => {
        const fecha = new Date(row.fechaEnvio!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Mínima fecha contable",
      selector: (row: RespuestaRegistrosEnviados) => {
        const fecha = new Date(row.fecMinContable!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Máxima fecha contable",
      selector: (row: RespuestaRegistrosEnviados) => {
        const fecha = new Date(row.fecMaxContable!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Débitos",
      selector: (row: RespuestaRegistrosEnviados) => `$${row.debe}` || '',
      cell: (row) => numericFormatter((row.debe ?? 0).toString(), {
              "thousandsGroupStyle": "thousand",
              "thousandSeparator": ".",
              "decimalSeparator": ",",
              "prefix": " $"
            }),
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Créditos",
      selector: (row: RespuestaRegistrosEnviados) => `$${row.haber}` || '',
      cell: (row) => numericFormatter((row.haber ?? 0).toString(), {
              "thousandsGroupStyle": "thousand",
              "thousandSeparator": ".",
              "decimalSeparator": ",",
              "prefix": " $"
            }),
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Usuario validador",
      selector: (row: RespuestaRegistrosEnviados) => row.usuario,
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Cantidad asientos",
      selector: (row: RespuestaRegistrosEnviados) => row.cantidadAsientos,
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
  ]

  return { COLUMNS };
}